














































import Vue, { PropType } from 'vue'
import GoogleRatingStars from '~/components/car/classifieds/view/partials/google-rating/GoogleRatingStars.vue'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import { Size } from '~/models/app/size'

export default Vue.extend({
  components: {
    GoogleRatingStars,
    CImg
  },
  props: {
    googleRating: {
      type: Object,
      required: true
    },
    noBorder: { type: Boolean, required: false, default: false },
    noShadow: { type: Boolean, required: false, default: false },
    whiteBackground: { type: Boolean, required: false, default: false },
    withoutSellerName: { type: Boolean, required: false, default: false },
    logoSize: {
      type: String as PropType<Size>,
      default: Size.LG
    }
  },
  computed: {
    size() {
      return Size
    }
  }
})
